import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import '../styles/Header.css';

function Header() {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <header className="header">
      <div className="header-container">
        <Link to="/" className="logo">
          <picture>
            <source srcSet="/Narek_Logo-removebg-preview.png" type="image/png" />
            <img src="/Narek_Logo-removebg-preview.png" alt="Comercial y Servicios Narek" loading="eager" />
          </picture>
        </Link>

        <button
          className="menu-toggle"
          onClick={toggleMenu}
          aria-label={menuOpen ? 'Cerrar menú de navegación' : 'Abrir menú de navegación'}
          aria-expanded={menuOpen}
          aria-controls="main-nav"
        >
          ☰
        </button>

        <nav id="main-nav" className={`nav ${menuOpen ? 'active' : ''}`} aria-label="Navegación principal">
          <Link to="/" onClick={() => setMenuOpen(false)}>Inicio</Link>
          <Link to="/contacto" onClick={() => setMenuOpen(false)}>Contacto</Link>
          <a href="/#galeria" onClick={() => setMenuOpen(false)}>Galería</a>
          <a href="/#servicios" onClick={() => setMenuOpen(false)}>Servicios</a>
        </nav>
      </div>
    </header>
  );
}

export default Header;
